export const URL_REGEX = '^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
export const AD_TARGETING_KEY_REGEX = '^[a-zA-Z][\\w_-]*$';
export const AD_TARGETING_VALUE_REGEX = '^[a-zA-Z].*$';
export const wildcard = (pattern: string): string => pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*');
export const isHeroPresetCollection = (value: string): boolean => /^heroPresetCollection$/.test(value);
export const isCollectionLink = (value: string): boolean => /^(collectionId|contentListId)$/.test(value);
export const isAsset = (value: string): boolean => /[\w-]+\/[a-f0-9]{24}\/[a-f0-9]{24}/.test(value);
export const isVixImage = (value: string): boolean => /https:\/\/images\..+(?=\.vix\.tv).vix.tv.*/.test(value);
export const isDuration = (value: string): boolean => /^duration$/.test(value);
